// extracted by mini-css-extract-plugin
module.exports = {"voorblad":"MkgAddOn_voorblad__44TbC","container":"MkgAddOn_container__hXdd9","titel":"MkgAddOn_titel__Lo_Zb","intro":"MkgAddOn_intro__2J0PJ","img":"MkgAddOn_img__ItXHB"};